import { Colors } from "../../types/types";

export const colors: Colors = {
    primary: "#030b21",
    secondary: "#4797ff",
    red: "#e00b24",
};
